<script>
export default {
  name: 'CheckboxTags',
  components: {},
  props: {
    allOpt: {
      type: Object,
      default: null,
    },
    isEmbed: {
      type: Boolean,
    },
    item: {
      type: Object,
      required: false,
      default: null,
    },
    items: {
      type: Array,
      required: false,
      default: null,
    },
    selectAll: {
      type: Boolean,
    },
    size: {
      type: String,
      default: 'lg',
    },
    onTabletUp: {
      type: Boolean,
    },
    validateSelect: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    validate(item) {
      const hasSelection =
        this.items.some((item) => item.isSelected === true) || item.isSelected;
      this.$emit('is-valid', hasSelection);
    },
    async selectItem(item) {
      if (this.allOpt && this.allOpt.isSelected) {
        this.allOpt.isSelected = false;
      }

      await this.toggleCheck(item);
      this.$emit('select-tag', item);
      if (this.validateSelect) {
        this.validate(item);
      }
    },
    async selectAllItems(item) {
      await this.toggleCheck(item);
      if (item.isSelected) {
        await this.items.forEach((item) => (item.isSelected = true));
      } else {
        await this.items.forEach((item) => (item.isSelected = false));
      }

      if (this.validateSelect) {
        this.validate(item);
      }
    },
    toggleCheck(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>

<template>
  <div>
    <div class="tags-wrapper">
      <div
        v-if="selectAll && allOpt"
        class="tag"
        @click="selectAllItems(allOpt)"
      >
        <div class="tag-name">
          {{ allOpt.name }}
        </div>
      </div>

      <span v-if="items">
        <span v-for="(itm, i) in items" :key="i" class="tag-group">
          <div
            :class="['tag', { selected: item.isSelected }]"
            @click="selectItem(itm)"
          >
            <div class="tag-name">
              {{ item.label }}
              <span class="icon-delete"
                ><img src="@assets/images/icon-times.svg"
              /></span>
            </div>
          </div>
        </span>
      </span>

      <span class="tag-group" v-if="item">
        <div
          :class="['tag', { selected: item.isSelected }]"
          @click="selectItem(item)"
        >
          <div class="tag-name">
            {{ item.label }}
            <span class="icon-delete"
              ><img src="@assets/images/icon-times.svg"
            /></span>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tags-wrapper {
  margin-bottom: 1rem;
  width: 100%;

  .tag-group {
    display: inline-block;

    .tag {
      background: $color-tag-bg;
      border-radius: $base-border-radius;
      margin: 0 0.5rem 1rem;
      padding: 1.2rem 1rem;
      text-align: center;
      transition: background $duration-animation-base;

      &:hover,
      &.selected {
        background-color: $color-action;
        cursor: pointer;
      }

      .tag-name {
        color: $color-tag-text;
        font-size: 1.5rem;
        font-weight: 600;
        letter-spacing: 0.125px;

        .icon-delete {
          margin-left: 1rem;
          position: relative;
          top: -0.2rem;

          img {
            width: 1.2rem;
          }
        }
      }
    }
  }
}
</style>
